<template>
    <div>
        <div v-if="theme == 'native'">
            <input type="file" @change="upload" accept="image/*" capture="camera">
        </div>
        <div v-else-if="theme == 'classic'">
            <div v-if="status == 'default'">
                <label class="ui icon basic disabled button">
                    <i class="upload icon"></i>
                    {{ button_text }}
                </label>
            </div>
            <div v-else-if="status == 'uploading'">
                <label class="ui icon basic loading button">
                    <i class="upload icon"></i>
                    {{ button_text }}
                </label>
            </div>
            <div v-else-if="status == 'ready'">
                <label :for="_uid + 'file_uploader'" class="ui icon basic button">
                    <i class="upload icon"></i>
                    {{ button_text }}
                </label>
                <input type="file" :id="_uid + 'file_uploader'" @change="upload" style="display: none;" ref="input_file_field" accept="image/*" capture="camera">
            </div>
        </div>
        <div v-else-if="theme == 'compact'">
            <div v-if="status == 'default'">
                <label class="ui icon basic disabled button">
                    <i class="upload icon"></i>
                </label>
            </div>
            <div v-else-if="status == 'uploading'">
                <label class="ui icon basic loading button">
                    <i class="upload icon"></i>
                </label>
            </div>
            <div v-else-if="status == 'ready'">
                <label :for="_uid + 'file_uploader'" class="ui icon basic button">
                    <i class="upload icon"></i>
                </label>
                <input type="file" :id="_uid + 'file_uploader'" @change="upload" style="display: none;" accept="image/*" capture="camera">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolFileUploaderMain",
    props: {
        theme: {
            type: String,
            default: "classic"
        },
        button_text: {
            type: String,
            default: "選擇檔案"
        },
        channel: String,
    },
    data() {
        return {
            status: "default",
            file: null,
            uploaded_file: null,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.$bus.$on(this.channel, (from, event_name, data) => {
            if (from != "file_uploader") {
                switch (event_name) {
                    case "show_uploaded_file":
                        this.$bus.$emit(this.channel, "file_uploader", "uploaded_file", this.uploaded_file)
                        break
                    case "open_file_browser":
                        $(this.$refs.input_file_field).click()
                        break
                }
            }
        })
        this.status = "ready"
    },
    watch: {
    },
    methods: {
        upload(e) {
            var file_upload_url = new RestUrl(
                "https://air.formosaas.com/api/v1/:app_id/cloud/:access_token/:identity/bucket/:bucket_identity/upload"
            ).parse(
                {
                    "app_id": this.$store.state.provider.node.air_service.air_app_id,
                    "access_token": this.$store.state.provider.node.air_service.air_access_token,
                    "identity": this.$store.state.provider.node.air_service.air_identity,
                    "bucket_identity": this.$store.state.provider.node.air_service.air_bucket_identity,
                    "air_authorization": this.$store.state.provider.node.air_service.air_authorization
                },
                "?authorization=" + this.$store.state.provider.node.air_service.air_authorization + "&is_froala=true"
            )
            this.file = e.target.files[0]
            this.status = "uploading"
            this.$bus.$emit(this.channel, "file_uploader", "uploading", this.file.name)
            if(this.file !== null && this.file !== undefined) {
                var form_data = new FormData()
                form_data.append('file', this.file)
                axios.post(
                    file_upload_url,
                    form_data)
                   .then(response => {
                       if (!response.data.link) {
                           console.log(response.data)
                           this.$bus.$emit(this.channel, "file_uploader", "upload failed", this.file.name)
                       }else {
                           this.$bus.$emit(this.channel, "file_uploader", "upload complete", decodeURIComponent(response.data.link))
                           this.uploaded_file = this.file
                           this.file = null
                       }
                   })
                   .catch(error => {
                       this.$bus.$emit(this.channel, "file_uploader", "upload failed", this.file.name)
                   }).then(() => {
                       this.status = "ready"
                   })
            }
        }
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
</style>
